module.exports = __webpack_public_path__ + "static/media/person8.915f2049.png";